import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueCookies from "vue-cookies";
import io from "socket.io-client";
import LoadScript from "vue-plugin-load-script";

Vue.use(VueCookies); // this.$cookies in component
Vue.use(LoadScript);
Vue.$cookies.config("30d", "", "", true); // set secure cookie. https only

Vue.config.productionTip = false;

window.socket = io("https://mwam1.bnology.com", {
  secure: true,
  query: "server=live"
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
